import { HttpException } from "http-repository-cache";
import MapperHttpExceptionToException from "../../mapperHttpExceptionToException/MapperHttpExceptionToException";
import { ApiResponse } from "../../../api/types/ApiResponse";
import { ApiResponseHandler } from "../handleApiResponse/handleApiResponse";
import Exception from "core/exceptions/Exception";
import DefaultExceptionTypes from "core/exceptions/DefaultExceptionTypes";
import { isNetworkFailure, serviceUnavailableException } from "core/exceptions/serviceUnavailable";

/**
 * Type guard to check if the error is an API response.
 */
function isApiResponse<T>(error: unknown): error is ApiResponse<T> {
  return (
    typeof error === "object" &&
    error !== null &&
    "code" in error &&
    "message" in error &&
    typeof (error as ApiResponse<T>).code === "string"
  );
}

/**
 * Handles HTTP request errors and API response errors
 * @param error - HTTP exception or API response error
 * @returns Exception object for the ViewModel to handle
 */
const handleRequestError = <T, B>(
  error: HttpException<T, B> | ApiResponse<T>,
): Exception<unknown, DefaultExceptionTypes> => {
  // Serveur arrêté ou réseau coupé : ce n'est pas un refus du serveur, l'écran doit le dire comme tel
  if (isNetworkFailure(error)) {
    return serviceUnavailableException();
  }

  // Check if it's an API response error using proper type guard
  if (isApiResponse<T>(error)) {
    if (ApiResponseHandler.isError(error)) {
      return ApiResponseHandler.createExceptionFromResponse(error);
    }
  }

  // Handle HTTP exceptions as before - return mapped exception
  return new MapperHttpExceptionToException().map(
    error as HttpException<T, B>,
  ) as Exception<unknown, DefaultExceptionTypes>;
};

export default handleRequestError;
